import { Banner } from "@brexhq/component-library";
import styled from "@emotion/styled";
import React, { useState, useEffect } from "react";

import useLocation from "@brexhq/next/src/hooks/useLocation";
import { isDev } from "@brexhq/shared/utils/env/isDevEnv";

const Container = styled.div(({ theme }) => ({
  background: theme.colors.accent.primary.background.default,
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  width: "100%",
  top: 0,
  zIndex: theme.zIndex.STAGING_BANNER,
  padding: theme.spacing.m10,
}));

const StagingBanner = () => {
  const location = useLocation();
  const [showStagingBanner, setShowStagingBanner] = useState(false);

  useEffect(() => {
    const isLocalHost = location.hostname === "localhost";
    const url = new URL(location.href);
    const isInPreviewMode = url.searchParams.has("isPreview");
    if (isDev && !isLocalHost && !isInPreviewMode) {
      setShowStagingBanner(true);
    }
  }, [location]);

  if (!showStagingBanner) return null;
  return (
    <Container id="staging-banner">
      <Banner
        variant="warning"
        title="Warning"
        onClose={() => setShowStagingBanner(false)}
      >
        <p style={{ color: "black", display: "inline" }}>
          This is a development version. If you are a Brex customer go back to
          <a href="https://brex.com"> brex.com</a>
        </p>
      </Banner>
    </Container>
  );
};

export default StagingBanner;
